









































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";
import FormSection from "@/components/FormSection.vue";
import DateInput from "@/components/DateInput.vue";
import MoneyInput from "@/components/MoneyInput.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import DisabledFieldTooltip from "../DisabledFieldTooltip.vue";
import IfaceSyncInvoiceItemDTO from "../../models/IfaceSyncInvoiceItemDTO";
import { optionDisplay } from "../../models/IfaceSyncDictionaryOption";
import store, { InterfaceStore } from "../../services/InterfaceStore";
import configuration from "@/models/Configuration";
import { Iface } from "../../models/Iface";

interface Data {
  store: InterfaceStore;
  Iface: typeof Iface;
}

interface SelectItem {
  text: string;
  value: string;
}

interface Methods {
  save(): void;
  itemDigits(currency: string | null): number;
  unitDigits(currency: string | null): number;
}

interface Computed {
  /** Áfakulcs választó elemei — a K2D megnevezés látszik, az érték a külső kód. */
  taxItems: SelectItem[];
}

interface Props {
  /** A szerkesztett számlatétel DTO — közvetlenül erre kötünk (a fej resync-je overlay-eli). */
  item: IfaceSyncInvoiceItemDTO;
  /** A fej locked állapota — ekkor minden mező tiltva (nem a legutolsó szinkron állapot). */
  locked: boolean;
  /** A számla pénzneme (a fejről) — a "szla. pénznemében" összegmezők tizedeseihez. */
  currency: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SyncInvoiceItemEdit",

  components: {
    FormSection,
    DateInput,
    MoneyInput,
    SyncStatusBadge,
    DisabledFieldTooltip,
  },

  props: {
    item: { type: Object as PropType<IfaceSyncInvoiceItemDTO>, required: true },
    locked: { type: Boolean, default: false },
    currency: { type: String, default: "HUF" },
  },

  data() {
    return { 
      store,
      Iface
    };
  },

  computed: {
    taxItems(): SelectItem[] {
      const items = this.store.taxOptions.map((o) => ({ text: optionDisplay(o), value: o.extCode }));
      const tax = this.item.tax;
      if (tax && !items.some((i) => i.value === tax)) {
        items.unshift({ text: tax, value: tax });
      }
      return items;
    },
  },

  methods: {
    /**
     * A tétel mentése — a mezők közvetlenül az item objektumon módosulnak, itt csak a
     * userModified flaget állítjuk (kék kiemelés + a fej resync-jekor modifiedItems-be kerül),
     * majd jelezzük a szülőnek (InvoiceItems), hogy zárja be a szerkesztő tabot.
     */
    save() {
      this.item.userModified = true;
      this.$emit("save", this.item);
    },

    /** Tétel szintű összeg tizedesjegyek az adott pénznemhez (GENI tétel digitek, HUF esetén 0). */
    itemDigits(currency: string | null): number {
      return configuration.getCurrDigits(currency ?? "HUF")?.geniItemDigits ?? 0;
    },

    /** Egységár tizedesjegyek az adott pénznemhez (GENI egységár digitek, HUF esetén 0). */
    unitDigits(currency: string | null): number {
      return configuration.getCurrDigits(currency ?? "HUF")?.geniUnitDigits ?? 0;
    },
  },
});
